import * as React from 'react';
import { ActionList } from '../ActionList';
import { ActionItemButton } from '../ActionItem';
import { Menu } from '../Menu';
import { Popover } from '../Popover';
import * as TextMenuElements from './TextMenu.styles';
export function TextMenu(props) {
    var right = props.right, defaultValue = props.defaultValue, value = props.value, onClickHandler = props.onClickHandler, options = props.options;
    if (value === undefined && defaultValue === undefined) {
        throw Error('TextMenu expects at least one of "value" or "defaultValue" properties.');
    }
    var _a = React.useState(value !== null && value !== void 0 ? value : defaultValue), selected = _a[0], setSelected = _a[1];
    var onClick = React.useCallback(function (option, close) {
        return function () {
            setSelected(option.value);
            if (onClickHandler !== undefined) {
                onClickHandler(option);
            }
            close();
        };
    }, []);
    return (React.createElement(Menu, null, function (_a) {
        var isOpen = _a.isOpen, toggle = _a.toggle, close = _a.close;
        return (React.createElement(React.Fragment, null,
            React.createElement(TextMenuElements.Trigger, { onClick: toggle }, selected),
            isOpen && (React.createElement(Popover, { right: right },
                React.createElement(ActionList, null, options.map(function (option) {
                    var _a;
                    return (React.createElement(ActionItemButton, { key: option.value, isActive: option.value === selected, onClick: onClick(option, close) }, (_a = option.label) !== null && _a !== void 0 ? _a : option.value));
                }))))));
    }));
}
//# sourceMappingURL=index.js.map